<template>
  <div class="service-txt">
    <h6 style="text-align:center; font-size: 16px">提示条款</h6>
    <p class="text">
      提示条款<br /><br />
欢迎您与各伟班经营者（详见定义条款）共同签署本《伟班服务协议》（下称“本协议”）并使用伟班服务！<br /><br />
各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。<br /><br />
【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对协议有任何疑问，可向伟班客服咨询。<br /><br />
【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与伟班达成一致，成为伟班“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。<br /><br />
一、定义<br /><br />
伟班：指伟班网站（域名为www.veiban.com）及客户端。<br /><br />
伟班：伟班经营者的单称或合称，指伟班网站经营者深圳优制云工业互联网有限公司。<br /><br />
用户：是指注册、登录、使用伟班的个人或组织。<br /><br />
伟班服务：伟班基于互联网，以包含伟班网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。<br /><br />
伟班规则：包括在所有伟班规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及发布的各类规则、实施细则、产品流程说明、公告等。<br /><br />
伟班规则：伟班规则频道列明的各项规则。<br /><br />
二、 协议范围<br /><br />
2.1 签约主体<br /><br />
【平等主体】本协议由您与伟班经营者共同缔结，本协议对您与伟班经营者均具有合同效力。<br /><br />
【主体信息】伟班经营者是指经营伟班的各法律主体，您可随时查看伟班首页底部公示的证照信息以确定与您履约的伟班主体。本协议项下，伟班经营者可能根据伟班的业务调整而发生变更，变更后的伟班经营者与您共同履行本协议并向您提供服务，伟班经营者的变更不会影响您本协议项下的权益。伟班经营者还有可能因为提供新的伟班服务而新增，如您使用新增的伟班服务的，视为您同意新增的伟班经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。<br /><br />
2.2补充协议<br /><br />
由于互联网高速发展，您与伟班签署的本协议列明的条款并不能完整罗列并覆盖您与伟班所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，伟班隐私权政策、法律声明及伟班规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用伟班服务，视为您同意上述补充协议。<br /><br />
三、 账户注册与使用<br /><br />
3.1 用户资格<br /><br />
您确认，在您开始注册程序使用伟班服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。<br /><br />
3.2 账户说明<br /><br />
【账户获得】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得伟班账户并成为伟班用户。<br /><br />
【账户使用】您有权使用您设置或确认的伟班会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录伟班。<br /><br />
由于您的伟班账户关联您的个人信息及伟班商业信息，您的伟班账户仅限您本人使用。未经伟班同意，您直接或间接授权第三方使用您伟班账户或获取您账户项下信息的行为无效。如伟班判断您伟班账户的使用可能危及您的账户安全或伟班信息安全的，伟班可拒绝提供相应服务或终止本协议。<br /><br />
【账户转让】由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经伟班同意，并符合伟班规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则伟班有权追究您的违约责任，且由此产生的一切责任均由您承担。<br /><br />
【实名认证】作为伟班经营者，为使您更好地使用伟班的各项服务，保障您的账户安全，伟班可要求您按我公司要求及我国法律规定完成实名认证。<br /><br />
3.3 会员名注册规则<br /><br />
会员在选择其伟班会员名、组织机构名、伟班店铺名或域名时应遵守国家法律法规，不得包含违法、涉嫌侵犯他人权利或干扰伟班运营秩序等相关信息。<br /><br />
3.3.1根据国家相关规定，伟班会员名、伟班店铺名及域名不得包含以下信息：<br /><br />
（1）同中华人民共和国的国家名称、国旗、国徽、军旗、勋章相同或者近似的，以及同中央国家机关所在地特定地点的名称或者标志性建筑物的名称、图形相同的；<br /><br />
（2）同外国的国家名称、国旗、国徽、军旗相同或者近似的，但该国政府同意的除外；<br /><br />
（3）同政府间国际组织的旗帜、徽记、名称相同或者近似的，但经该组织同意或者不易误导公众的除外；<br /><br />
（4）与表明实施控制、予以保证的官方标志、检验印记相同或者近似的，但经授权的除外；<br /><br />
（5）同“红十字”、“红新月”的标志、名称相同或者近似的；<br /><br />
（6）同第三方标志相同或者近似的，如：中国邮政、中国电信、中国移动、中国联通、中国网通和中国铁通等；<br /><br />
（7）带有民族歧视性的；<br /><br />
（8）夸大宣传并带有欺骗性的；<br /><br />
（9）有害于社会主义道德风尚或者有其他不良影响的；<br /><br />
（10）县级以上行政区划的地名或者公众知晓的外国地名，不得作为店标，但是，地名具有其他含义的除外；<br /><br />
（11）带有种族歧视、仇恨、性和淫秽信息的语言；<br /><br />
（12）违背公序良俗的不良信息或令人反感的信息；<br /><br />
（13）含有不真实内容或者误导消费者的内容；<br /><br />
（14）其他涉嫌违反法律法规的内容。<br /><br />
3.3.2伟班会员名、组织机构名、伟班店铺名及域名中不得包含干扰伟班运营秩序的信息，包括但不限于以下情形：<br /><br />
（1）会员名、组织机构、店铺名或域名中，包含未经伟班授权、许可使用的名称、标识或其他信息。如：<br /><br />
1)含有“伟班特许”、“伟班授权”及近似含义的词语；<br /><br />
2)“伟班”、\"伟班\"等代表伟班特殊含义的词语或标识；<br /><br />
3)与伟班信用评价相关的词语或标识；<br /><br />
4)深圳市华瀚科技控股有限公司及旗下其他公司的名称或标识；<br /><br />
（2）会员名、组织机构、店铺名或域名中，包含伟班相关机构或组织名义信息，以及虚假的伟班资质或伟班特定服务、活动等信息。如：<br /><br />
1)非商盟店铺的店铺名命名为**商盟，或非商盟的店铺在店铺中使用商盟进行宣传；<br /><br />
2)不具有相关资质或未参加伟班相关活动的会员或店铺，使用与特定资质或活动相关的特定含义的词语，例如：华东区、消费者保障计划、先行赔付等。<br /><br />
（3）其他伟班禁止使用的信息。<br /><br />
3.4注册信息管理<br /><br />
3.4.1 真实合法<br /><br />
【信息真实】在使用伟班服务时，您应当按伟班页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便伟班或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。<br /><br />
【会员名的合法性】您设置的伟班会员名不得违反国家法律法规及伟班规则关于会员名的管理规定，否则伟班可回收您的伟班会员名。伟班会员名的回收不影响您以邮箱、手机号码登录伟班并使用伟班服务。<br /><br />
3.4.2 更新维护<br /><br />
您应当及时更新您提供的信息，在法律有明确规定要求伟班作为平台服务提供者必须对部分用户（如平台卖家等）的信息进行核实的情况下，伟班将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。<br /><br />
如伟班按您最后一次提供的信息与您联系未果、您未按伟班的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及伟班造成的全部损失与不利后果。伟班可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部伟班服务，伟班对此不承担责任。<br /><br />
3.5账户安全规范<br /><br />
【账户安全保管义务】您的账户为您自行设置并由您保管，伟班任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户， 并确保您在每个上网时段结束时退出登录并以正确步骤离开伟班。<br /><br />
账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，伟班并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。<br /><br />
【账户行为责任自负】除伟班存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。<br /><br />
【日常维护须知】如发现任何未经授权使用您账户登录伟班或其他可能导致您账户遭窃、遗失的情况，建议您立即通知伟班。您理解伟班对您的任何请求采取行动均需要合理时间，且伟班应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除伟班存在法定过错外，伟班不承担责任。<br /><br />
四、 伟班服务<br /><br />
4.1 客户端服务内容<br /><br />
4.1.1 本服务的具体内容由伟班客户端（包含移动端和PC端）根据实际情况提供，包括但不限于授权用户通过其账号进行即时通讯、传送文件、查阅新闻资讯等。伟班可以对其提供的服务予以变更，且伟班提供的服务内容可能随时变更；用户将会收到伟班关于服务变更的通知。<br /><br />
4.1.2 伟班客户端提供的服务包含企业组织架构，用户即时通讯、群聊，传送文件，考勤打卡等。<br /><br />
4.2伟班网站服务内容<br /><br />
伟班提供的服务内容众多，除客户端的内容外，您还可以用注册账号登录伟班网站（域名为www.epipe.cn）获取额外的服务，具体您可登录伟班浏览，包括但不限于浏览管道行业新闻咨询，下载在线资源，咨询商品，购买商品并进行评价，申请开通店铺，商品或服务的销售与推广等。<br /><br />
4.3费用<br /><br />
伟班为平台向您提供的服务付出了大量的成本，除伟班明示的收费业务外，伟班向您提供的服务目前是免费的。如未来伟班向您收取合理费用，伟班会采取合理途径并以足够合理的期限提前通过法定程序并以本协议第八条约定的方式通知您，确保您有充分选择的权利。<br /><br />
4.4 责任限制<br /><br />
【不可抗力及第三方原因】伟班依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，伟班并不承担相应的违约责任：<br /><br />
（一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br /><br />
（二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；<br /><br />
（三）在伟班已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。<br /><br />
【海量信息】伟班仅向您提供伟班服务，您了解伟班上的信息系用户自行发布，且可能存在风险和瑕疵。鉴于伟班具备存在海量信息及信息网络环境下信息与实物相分离的特点，伟班无法逐一审查商品或服务的信息，无法逐一审查交易所涉及的商品或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。<br /><br />
【调处决定】您理解并同意，在争议调处服务中，伟班的客服并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，调处方对争议调处决定免责。<br /><br />
五、 用户信息的保护及授权<br /><br />
5.1个人信息的保护<br /><br />
伟班非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用伟班提供的服务时，您同意伟班按照在伟班上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。伟班希望通过隐私权政策向您清楚地介绍伟班对您个人信息的处理方式，因此伟班建议您完整地阅读隐私权政策（点击此处或点击伟班首页底部链接），以帮助您更好地保护您的隐私权。<br /><br />
5.2非个人信息的保证与授权<br /><br />
【信息的发布】您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，伟班可对您发布的信息依法或依本协议进行删除或屏蔽。<br /><br />
【禁止性信息】您应当确保您所发布的信息不包含以下内容：<br /><br />
（一）违反国家法律法规禁止性规定的；<br /><br />
（二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；<br /><br />
（三）欺诈、虚假、不准确或存在误导性的；<br /><br />
（四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；<br /><br />
（五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；<br /><br />
（六）存在可能破坏、篡改、删除、影响伟班任何系统正常运行或未经授权秘密获取伟班及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；<br /><br />
（七）其他违背社会公共利益或公共道德或依据相关伟班协议、规则的规定不适合在伟班上发布的。<br /><br />
【授权使用】对于您提供及发布除个人信息外的文字、图片、视频、音频等非个人信息，在版权保护期内您免费授予伟班及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用的权利。您同意伟班及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。<br /><br />
六、 用户的违约及处理<br /><br />
6.1 违约认定<br /><br />
发生如下情形之一的，视为您违约：<br /><br />
（一）使用伟班服务时违反有关法律法规规定的；<br /><br />
（二）违反本协议或本协议补充协议（即本协议第2.2条）约定的。<br /><br />
为适应互联网发展和满足海量用户对高效优质服务的需求，您理解并同意，伟班可在伟班规则中约定违约认定的程序和标准。如：伟班可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。<br /><br />
6.2 违约处理措施<br /><br />
【信息处理】您在伟班上发布的信息构成违约的，伟班可根据相应规则立即对相应信息进行删除、屏蔽处理。<br /><br />
【行为限制】您在伟班上实施的行为，或虽未在伟班上实施但对伟班及其用户产生影响的行为构成违约的，伟班可依据相应规则对您执行账户扣分、限制参加营销活动、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，伟班可查封您的账户，终止向您提供服务。<br /><br />
【处理结果公示】伟班可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在伟班上予以公示。<br /><br />
6.3赔偿责任<br /><br />
如您的行为使伟班或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿伟班或其关联公司的上述全部损失。<br /><br />
如您的行为使伟班或其关联公司遭受第三人主张权利，伟班或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。<br /><br />
6.4特别约定<br /><br />
【商业贿赂】如您向伟班或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，伟班可立即终止与您的所有合作并向您收取违约金或赔偿金，该等金额以伟班因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。<br /><br />
【关联处理】如您因严重违约导致伟班终止本协议时，出于维护平台秩序及保护消费者权益的目的，伟班或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议第八条约定的方式通知您。<br /><br />
如伟班与您签署的其他协议及伟班或其关联公司与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，则伟班出于维护平台秩序及保护消费者权益的目的，可在收到指令时中止甚至终止协议，并以本协议第八条约定的方式通知您。<br /><br />
七、 协议的变更<br /><br />
伟班可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第八条约定的方式通知您。<br /><br />
如您不同意变更事项，您有权于变更事项确定的生效日前联系伟班反馈意见。如反馈意见得以采纳，伟班将酌情调整变更事项。<br /><br />
如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用伟班服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用伟班服务，则视为您同意已生效的变更事项。<br /><br />
八、 通知<br /><br />
8.1有效联系方式<br /><br />
您在注册成为伟班用户，并接受伟班服务时，您应该向伟班提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。<br /><br />
您在注册伟班用户时生成的用于登陆伟班接收站内信、系统消息的会员账号（包括子账号），也作为您的有效联系方式。<br /><br />
伟班将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。<br /><br />
您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过伟班提供的相应的退订功能进行退订。<br /><br />
8.2 通知的送达<br /><br />
伟班通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在伟班公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。<br /><br />
对于在伟班上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在伟班注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。<br /><br />
您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。<br /><br />
您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。<br /><br />
你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。<br /><br />
九、 协议的终止<br /><br />
9.1 终止的情形<br /><br />
【用户发起的终止】您有权通过以下任一方式终止本协议：<br /><br />
（一）在满足伟班公示的账户注销条件时您通过网站自助服务注销您的账户的；<br /><br />
（二）变更事项生效前您停止使用并明示不愿接受变更事项的；<br /><br />
（三）您明示不愿继续使用伟班服务，且符合伟班终止条件的。<br /><br />
【伟班发起的终止】出现以下情况时，伟班可以本协议第八条的所列的方式通知您终止本协议：<br /><br />
（一）您违反本协议约定，伟班依据违约条款终止本协议的；<br /><br />
（二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，伟班依据伟班规则对您的账户予以查封的；<br /><br />
（三）除上述情形外，因您多次违反伟班规则相关规定且情节严重，伟班依据伟班规则对您的账户予以查封的；<br /><br />
（四）您的账户被伟班依据本协议回收的；<br /><br />
（五）您有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；<br /><br />
（六）其它应当终止服务的情况。<br /><br />
9.2 协议终止后的处理<br /><br />
【用户信息披露】本协议终止后，除法律有明确规定外，伟班无义务向您或您指定的第三方披露您账户中的任何信息。<br /><br />
【伟班权利】本协议终止后，伟班仍享有下列权利：<br /><br />
（一）继续保存您留存于伟班的本协议第五条所列的各类信息；<br /><br />
（二）对于您过往的违约行为，伟班仍可依据本协议向您追究违约责任。<br /><br />
【交易处理】本协议终止后，对于您在本协议存续期间产生的交易订单，伟班可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。<br /><br />
十、 法律适用、管辖与其他<br /><br />
【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例或行业惯例。<br /><br />
【管辖】您因使用伟班服务所产生及与伟班服务有关的争议，由伟班与您协商解决。协商不成时，任何一方均可向被告所在地人民法院提起诉讼。<br /><br />
【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.service-txt {
  width: 100vw;
  font-size: 16px;
  padding: .2rem;
}
.text {
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 17px;
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>